import React, { useEffect, useState } from 'react';
import { billsApi } from '../../api/billsApi';

interface ReceiptHtmlViewerProps {
  billId: string;
  className?: string;
  minHeight?: string | number;
}

export const ReceiptHtmlViewer: React.FC<ReceiptHtmlViewerProps> = ({
  billId,
  className = '',
  minHeight = '70vh',
}) => {
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);
  const [htmlContent, setHtmlContent] = useState('');

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setFailed(false);
      setHtmlContent('');

      try {
        const html = await billsApi.fetchReceiptHtml(billId);
        if (!cancelled) {
          setHtmlContent(html);
        }
      } catch {
        if (!cancelled) {
          setFailed(true);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    if (billId) {
      load();
    }

    return () => {
      cancelled = true;
    };
  }, [billId]);

  return (
    <div className="relative w-full bg-gray-100" style={{ minHeight }}>
      {loading && !failed && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-50">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500" />
          <span className="ml-2 text-gray-600 text-sm">Đang tải phiếu thu...</span>
        </div>
      )}
      {failed ? (
        <div className="flex items-center justify-center py-16 text-gray-500 text-sm">
          Không thể tải phiếu thu
        </div>
      ) : htmlContent ? (
        <iframe
          title="Phiếu thu"
          srcDoc={htmlContent}
          className={`w-full border-0 bg-white ${className}`}
          style={{ minHeight, display: 'block' }}
          sandbox="allow-same-origin allow-scripts"
        />
      ) : null}
    </div>
  );
};

export function printReceipt(billId: string): void {
  window.open(billsApi.getReceiptHtmlUrl(billId, true), '_blank');
}

export function openReceiptInNewTab(billId: string): void {
  window.open(billsApi.getReceiptHtmlUrl(billId), '_blank');
}
